module.exports = __webpack_public_path__ + "img/karantena.a58bbc28.jpg";